import styled, {keyframes, useTheme} from "styled-components";
import merge from "lodash/merge";
import get from "lodash/get";
import React from "react";

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const LoaderElement = styled.div`
  display: inline-block;
  border: 2px solid #f3f3f3;
  border-top: 2px solid ${({theme}) => theme.v2.color.primary};
  border-radius: 50%;
  width: 14px;
  height: 14px;
  animation: ${spin} 1s linear infinite;
`;

const Loader = props => {
  const theme = useTheme();
  const _theme = {v2: merge({}, theme.v2, get(theme.v2, "overrides.loader"))};

  return <LoaderElement {...props} theme={_theme} />;
};

export default Loader;
